import { useState } from 'react';
import { useImportScript } from '.';

declare global {
  interface Window {
    grecaptcha: any;
  }
}

type UseGoogleRecaptchaType = {
  apiURL: string;
  apiKey: string;
};

export type RecaptchaType = {
  token: string;
};

export const useGoogleRecaptcha = ({ apiURL, apiKey }: UseGoogleRecaptchaType) => {
  const { isLoaded } = useImportScript(apiURL + apiKey);

  const [execute, setExecute] = useState<any>();

  const ready = isLoaded ? window.grecaptcha.ready : undefined;

  if (isLoaded && ready) {
    ready(() => {
      setExecute(() => window.grecaptcha.execute);
    });
  }

  return {
    execute,
  };
};
